import styled, { css } from 'styled-components'
import DownArrowIcon from '../../../../../assets/icons/down-arrow-icon.svg'
import LeftArrowIcon from '../../../../../assets/icons/left-arrow-icon.svg'
import RightArrowIcon from '../../../../../assets/icons/right-arrow-icon.svg'
import DownArrowGreen from '../../../../../assets/icons/chevron-down-pa.svg'
import CloseIcon from '../../../../../assets/icons/close-icon-pa.svg'

export const DatePickerContainer = styled.div`
  position: relative;
  flex: 1;
  font-family: Open Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 145%;
  height: ${({ height }) => height ? `${height} !important` : '48px !important'};
  .react-datepicker-wrapper {
    width: 100%;
    .form-control {
      font-size: 14px;
      max-width: ${({ width }) => width ? `${width}` : 'initial'};
      height: ${({ height }) => height ? `${height} !important` : '48px !important'};
      border: 1px solid #999999;
      border-radius: 8px;
      padding: 16px;
      padding-top: 20px !important;
      color: #777;
      &:focus,
      &:hover {
        border: 1px solid #999999 !important;
      }
      &:disabled {
        &:hover {
          border-color:#777777 !important;
        }
      }
      ${({ showIcon, invertIcon }) => (showIcon && !invertIcon) && css`
        padding-left: 42px;
      `}
    }
  }
  .react-datepicker {
    width: 346px;
    border: none;
    border-radius: 12px;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12), 0px 4px 8px rgba(0, 0, 0, 0.08);
    z-index: 1;
    &-popper {
      z-index: 2;
    }
    &__triangle {
      display: none;
    }
    &__month-container {
      width: 100%;
      padding-bottom: 32px;
    }
    &__month {
      margin-top: 8px;
      margin-bottom: 8px;
    }
    &__header {
      background-color: #fff;
      padding: 0;
      border: none;

      select {
        &:after {
          color: #028BB7 !important;
        }
      }
    }
    ${({ hideCurrentMonth }) => hideCurrentMonth && `
        &__current-month,
        &__navigation {
          display: none;
        }
      `}
    &__current-month {
      font-family: 'Nunito';
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 48px;
      color: #555555;
      padding: 16px 0 8px 0;
      text-transform: capitalize;
    }
    ${({ hideCurrentMonth }) => hideCurrentMonth && `
        &__header__dropdown {
          font-family: 'Nunito';
          font-style: normal;
          font-weight: 600;
          font-size: 16px;
          line-height: 19px;
          letter-spacing: 0.96px;
          padding: 0px 0 8px 0;
          color: #555555;
        }
      `}
    &__month-read-view--down-arrow,
    __year-read-view--down-arrow {
      background-image: url(${DownArrowIcon});
    }
    &__week {
      display: flex;
      justify-content: space-around;
      padding: 0 16px;
    }
    &__navigation {
      width: 48px;
      height: 48px;
      border: none;
      background-repeat: no-repeat;
      background-size: 10px 18px;
      background-position: center;
      top: 16px;
      &--previous {
        background-image: url(${LeftArrowIcon});
        left: 16px;
      }
      &--next {
        background-image: url(${RightArrowIcon});
        right: 16px;
      }
      &:focus {
        outline: none;
      }
    }
    &__day-names {
      display: flex;
      justify-content: center;
      padding: 0 16px;
    }
    &__day-name {
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 17px;
      text-align: center;
      color: #555555;
      text-transform: uppercase;
      flex: 1;
      max-width: 38px;
    }
    &__day {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: 'Nunito';
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 16px;
      text-align: center;
      letter-spacing: 0.96px;
      color: #555555;
      margin: 4px 0;
      max-width: 38px;
      min-height: 38px;
      border-radius: 100%;
      &--keyboard-selected {
        background: #fff;
        color: #555555;
      }
      &--outside-month {
        color: #DADADA;
      }
      &--selecting-range-start,
      &--selecting-range-end {
        background: #028BB7;
        color: #fff;
      }
      &--in-range,
      &--in-selecting-range {
        background: #B3EDF0;
        color: #222;
      }
      &--selected,
      &--range-start,
      &--range-end {
        background: #028BB7;
        color: #fff;
      }
      &--today {
        border: 2px solid #B3EDF0;
        background: transparent;
        color: #222;
        font-weight: 700;
        font-size: 16px;
      }
      &--disabled:not(.react-datepicker__day--outside-month) {
        opacity: .25;
      }
    }
    .start {
      background: #028BB7;
      color: #fff;
    }
    .end {
      background: #028BB7;
      color: #fff;
    }
  }
  .react-datepicker__input-container {
    button:after {
      width: 16px;
      height: 16px;
      padding: 0px 16px 2px 0px;
      background-color: #fff;
      color: #028BB7;
      font-size: 34px;
    }

    .react-datepicker__close-icon {
      padding: 0 16px 0 0;
      &:after {
        margin-top: 2px;
        padding: 0;
        padding-top: 2px;
        width: 100%;
        height: 100%;
        font-size: unset;
        content: url(${CloseIcon});
      }
    }
  }
  ${({ invertIcon }) => invertIcon && css`
    ${Icon} {
      left: initial;
      right: 16px;
    }
  `}
  ${({ showIcon }) => showIcon && css`
    ${Icon} {
      height: ${({ height }) => height || '48px'};
    }
  `}
  ${({ hasError }) => hasError && css`
    ${Label} {
      color: #C80E3B;
      background: linear-gradient(0deg,rgba(255,255,255,0) 45%,#fff 45%);
    }
    ${Icon} {
      path {
          fill: #C80E3B;
      }
    }
    .react-datepicker-wrapper .form-control {
      border: 2px solid #C80E3B;
      &:hover {
        border: 2px solid #C80E3B !important;
      }
    }
  `}
`
export const Label = styled.label`
  position: absolute;
  top: -10.6px;
  left: 14px;
  margin: 0px;
  background: rgb(255,255,255);
  color: #555;
  font-size: 14px;
  line-height: normal;
  font-family: 'Open Sans';
  font-weight: 400;
  padding: 4px;
  z-index: 1;
`
export const Icon = styled.div`
  display: flex;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 16px;
  margin: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
`
export const ErrorMessage = styled.p`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  padding-left: 15px;
  margin: 0;
  color: #C80E3B;
  position: absolute;
  bottom: -19.5px;
`

export const DateHeader = styled.div`
  margin: 0;
  height: 48px;
  display: flex;
  justify-content: center;
  gap: 24px;
  margin: 16px 0 8px 0;
`
export const SelectWrapper = styled.div`
  position:relative;
  display: flex;
  align-items: center;
  &::after {
    content: '';
    display: block;
    position: absolute;
    right: 0px;
    top: calc(50% - 5px);
    width: 18px;
    height: 10px;
    background-image: url(${DownArrowGreen});
    background-repeat: no-repeat;
    background-position: center;
    z-index: 1;
  }
`
export const Select = styled.select`
  border: none;
  width: fit-content;
  text-align: center;
  font-family: Nunito;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.96px;
  color: #555555;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding: 0 26px 0 0;
  z-index: 2;
  background-color: transparent;
  cursor: pointer;
  ${({ minWidth }) => minWidth && css`
    min-width: ${minWidth};
  `}
  &:focus-visible {
    outline: none;
  }
`
